interface Props {
  role: string;
  roles: string | undefined;
  children: React.ReactNode;
}

export const PermissionsFlag = ({ role, roles, children }: Props) => {
  if (!(roles === role)) {
    return null;
  }

  return <>{children}</>;
};
